/**
 * 性能埋点上报
 */
import { BridgeType, callGrowthMSIBridge, callKNBUseBridge, callMSIBridge, getBridgeType } from "./base";

interface RecordStepProps {
  stepName: string;
}

const bridgeType = getBridgeType();

export default function recordStep(props?: RecordStepProps) {
  const stepName = props?.stepName || '';
  switch (bridgeType) {
    case BridgeType.KNB:
      callKNBUseBridge("meituan.recordStep", {
        params: {
          stepName,
          stepTime: Date.now(),
        }
      });
      break;
    case BridgeType.MSI:
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("recordStep", { step: stepName });
      break;
    default:
      break;
  }
}
